export default "__VITE_ASSET__b92ce010__"